import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface IGetStepsDataTableStructure {
  rowActions?: DataTableRowActions;
  createAction?: () => void;
}

export const getStepsDataTableStructure = ({ rowActions, createAction }: IGetStepsDataTableStructure): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.id',
    accessorKey: 'etapeId',
    variant: DataTableColumnVariant.TEXT,
  };

  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.nom',
    accessorKey: 'etapeNom',
    variant: DataTableColumnVariant.TEXT,
  };

  const typeDossierColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.typeDossier',
    accessorKey: 'typeDossierLibelle',
    variant: DataTableColumnVariant.TEXT,
  };

  const modeEvaluationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.modeEvaluation',
    accessorKey: 'modeEvaluationCode',
    variant: DataTableColumnVariant.TEXT,
  };

  const orderEvaluationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.edit.steps.table.orderEvaluation',
    accessorKey: 'orderEvaluation',
    variant: DataTableColumnVariant.TEXT,
  };

  const isPublicColumn: DynamicDataTableColumn = {
    label: 'settings.dacScenarios.form.public.label',
    accessorKey: 'isPublic',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value ? 'settings.dacScenarios.form.yes' : 'settings.dacScenarios.form.no' };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'success' : 'danger';
      },
    },  };

  const isEliminatoireColumn: DynamicDataTableColumn = {
    label: 'settings.dacScenarios.form.eliminatoire.label',
    accessorKey: 'isEliminatoire',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value ? 'settings.dacScenarios.form.yes' : 'settings.dacScenarios.form.no' };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'success' : 'danger';
      },
    },
  };

  const hasSeuilColumn: DynamicDataTableColumn = {
    label: 'settings.dacScenarios.form.hasSeuil.label',
    accessorKey: 'hasSeuil',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean | null | undefined) => {
      if (value === null || value === undefined) return { value: '-' };
      return { value: value ? 'settings.dacScenarios.form.yes' : 'settings.dacScenarios.form.no' };
    },
    props: {
      getSeverity: (value: boolean | null | undefined) => {
        if (value === null || value === undefined) return 'secondary';
        return value ? 'success' : 'danger';
      },
    },
  };

  const hasPonderationColumn: DynamicDataTableColumn = {
    label: 'settings.dacScenarios.form.hasPonderation.label',
    accessorKey: 'hasPonderation',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean | null | undefined) => {
      if (value === null || value === undefined) return { value: '-' };
      return { value: value ? 'settings.dacScenarios.form.yes' : 'settings.dacScenarios.form.no' };
    },
    props: {
      getSeverity: (value: boolean | null | undefined) => {
        if (value === null || value === undefined) return 'secondary';
        return value ? 'success' : 'danger';
      },
    },
  };

  return {
    singular: 'settings.dacScenarios.table.step.singular',
    plural: 'settings.dacScenarios.table.step.plural',
    columns: [idColumn, nameColumn, typeDossierColumn, modeEvaluationColumn, orderEvaluationColumn, isPublicColumn, isEliminatoireColumn, hasSeuilColumn, hasPonderationColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    rowActions,
    createAction,
    searchableFields: ['etapeId', 'etapeNom', 'typeDossierLibelle', 'modeEvaluationCode', 'orderEvaluation', 'isPublic', 'isEliminatoire', 'hasSeuil', 'hasPonderation'],
  };
};
